// extracted by mini-css-extract-plugin
export default {"wrapper":"N8-z"};